import React, { useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import { useStores } from '../../data/store'
import { NewColumns } from './NewColumns'
import { NewRows } from './NewRows'

interface CheckboxGridProps {
  onHeaderSelectionChange: (selectedItem: any) => void
  isEditMode?: boolean
  cardsSelectDeselectAll: (isSelected: boolean, cardType: string) => void
  cardsColumnSelectionChange: (columnName: string, isSelected: boolean) => void
  cardsRowsSelectionChange: (cardType: string, cardSchemeName: string, rowItem: any, isSelected: boolean) => void
  cardsIndividualCheckChange: (cardType: string, columnName: string, item: any, isSelected: boolean) => void
}

const NewCheckboxGrid = React.memo(
  ({
    onHeaderSelectionChange,
    isEditMode,
    cardsSelectDeselectAll,
    cardsColumnSelectionChange,
    cardsRowsSelectionChange,
    cardsIndividualCheckChange,
  }: CheckboxGridProps) => {
    const { getIsSelectedCardTypeFullySelected, getUpdatedCardsList } = useStores((root) => ({
      getIsSelectedCardTypeFullySelected: root.getIsSelectedCardTypeFullySelected,
      getUpdatedCardsList: root.onboarding.getUpdatedCardsList,
    }))

    const [cardsList, setCardsList] = useState([])
    const [selectedType, setSelectedType] = useState('110')

    const keyExtractor = (item: any): string => {
      return item.id
    }

    const handleHeaderSelectionChange = (selectedItem: any) => {
      onHeaderSelectionChange(selectedItem)
      setSelectedType(`${selectedItem.id}`)
    }

    const renderWithUpdatedData = () => {
      if (selectedType) {
        const updatedSelectionData = getUpdatedCardsList(selectedType)
        setCardsList(updatedSelectionData)
      }
    }

    const handleSelectDeselectAll = (isAllSelected: boolean, cardType: string) => {
      cardsSelectDeselectAll(isAllSelected, cardType)
      renderWithUpdatedData()
    }

    const handleCardsColumnSelectionChange = (columnName: string, isSelected: boolean) => {
      cardsColumnSelectionChange(columnName, isSelected)
      renderWithUpdatedData()
    }

    const handleIndividualCheckChange = (cardType: string, columnName: string, item: any, isSelected: boolean) => {
      cardsIndividualCheckChange(cardType, columnName, item, isSelected)
      renderWithUpdatedData()
    }

    const handleCardsRowsSelectionChange = (
      cardType: string,
      cardSchemeName: string,
      rowItem: any,
      isSelected: boolean,
    ) => {
      cardsRowsSelectionChange(cardType, cardSchemeName, rowItem, isSelected)
      renderWithUpdatedData()
    }

    useEffect(() => {
      if (selectedType) {
        const updatedSelectionData = getUpdatedCardsList(selectedType)
        setCardsList(updatedSelectionData)
      }
    }, [getUpdatedCardsList, selectedType])

    return (
      <FlatList
        data={cardsList}
        renderItem={({ item, index }) => (
          <NewRows
            item={item}
            mainIndex={index}
            stateArray={cardsList}
            isSelectAllChecked={getIsSelectedCardTypeFullySelected(selectedType)}
            isEditMode={isEditMode}
            cardsRowsSelectionChange={handleCardsRowsSelectionChange}
            cardsIndividualCheckChange={handleIndividualCheckChange}
          />
        )}
        keyExtractor={keyExtractor}
        ListHeaderComponent={() => (
          <NewColumns
            isSelectAllChecked={getIsSelectedCardTypeFullySelected(selectedType)}
            onHeaderSelectionChange={handleHeaderSelectionChange}
            isEditMode={isEditMode}
            cardsSelectDeselectAll={handleSelectDeselectAll}
            cardsColumnSelectionChange={handleCardsColumnSelectionChange}
          />
        )}
        extraData={cardsList}
      />
    )
  },
)

export { NewCheckboxGrid }
